import { combineReducers } from "@reduxjs/toolkit";
import subscription from "./account/subscription";
import globalSlice from "slices/global";
import filtersSlice from "slices/filters";
import cartSlice from "slices/cart";
import profileSlice from "slices/profile";

const reducers = combineReducers({
	account: combineReducers({ profile: profileSlice, subscription }),
	cart: cartSlice,
	filters: filtersSlice,
	global: globalSlice,
});

export default reducers;
